import * as React from 'react';
import { OnCellPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import FormInput from '../../../../common/form/Input';
import FormSelectLabeled from '../../../../common/form/SelectLabeled';
import { CollectionType, VirtualToursEnabled } from '../../../../../utilities/Enums';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: OnCellPropertyConfiguration;
    update: (newConfig?: OnCellPropertyConfiguration) => void;
}

const OnCellConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Explore"
        cardOpen={!!props.config}
        onCardOpenChange={newValue =>{
            if (isUser)  return;
            props.update(
                newValue
                    ? ({
                        onCellProjectId: 0,
                        finalStep: '',
                        signinCompletesTour: false
                    } as OnCellPropertyConfiguration)
                    : undefined
            )
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Collection ID',
                            invalidText: 'Please enter an Explore Collection ID'
                        }}
                        inputProps={{
                            id: 'explore-collection-id',
                            name: 'collectionId',
                            value: props.config.collectionId || '',
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                collectionId:
                                    typeof value === 'number' ? value : parseInt(value, 10)
                            })
                        }
                    />

                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Collection Type'

                        }}
                        selectProps={{
                            id: 'explore-collection-type',
                            name: 'collectionType',
                            value: props.config.collectionType,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            {
                                value: CollectionType.List,
                                label: 'List'
                            },
                            {
                                value: CollectionType.Tour,
                                label: 'Tour'
                            }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                collectionType:
                                    typeof value === 'number'
                                        ? value
                                        : parseInt(value!.toString(), 10)
                            })
                        }
                    />

                    <FormInput
                        labelProps={{
                            labelText: 'Explore Final Tour Step Name',
                            invalidText: 'Please enter the name of the final tour step'
                        }}
                        inputProps={{
                            id: 'explore-final-step',
                            name: 'exploreFinalStep',
                            value: props.config.finalStep || '',
                            type: 'string',
                            required: false,
                            disabled: isUser
                        }}
                        helpTextProps={{
                            helpText:
                                'Name of the page that the last beacon of the Explore tour is linked to. ' +
                                'If this field is set and a prospect does not visit the specified beacon ' +
                                'then the leasing office will be ' +
                                'notified that the prospect may still be on the premises in the tour feedback email'
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, finalStep: value.toString() })
                        }
                    />

                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'No-Show Options'
                        }}
                        selectProps={{
                            id: 'signin-completes-tour-enable',
                            name: 'enableSigninCompletesTour',
                            value: props.config.signinCompletesTour,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            { value: true, label: 'App Sign In indicates Completed Tour' },
                            { value: false, label: 'Beacon Ping indicates Completed Tour' }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({ ...props.config!, signinCompletesTour: !!value })
                        }
                    />
                    <FormSelectLabeled
                        labelProps={{
                            labelText: 'Virtual Tour Options'
                        }}
                        selectProps={{
                            id: 'virtual-tour-options',
                            name: 'enableVirtualTour',
                            value: props.config.virtualToursEnabled,
                            required: true,
                            disabled: isUser
                        }}
                        selectOptions={[
                            {
                                value: VirtualToursEnabled.Disabled,
                                label: 'Disabled'
                            },
                            {
                                value: VirtualToursEnabled.EnabledAsOption,
                                label: 'Enabled As Option'
                            },
                            {
                                value: VirtualToursEnabled.EnabledAsOnlyOption,
                                label: 'Enabled As Only Option'
                            }
                        ]}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                virtualToursEnabled:
                                    typeof value === 'number'
                                        ? value
                                        : parseInt(value!.toString(), 10)
                            })
                        }
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default OnCellConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/OnCellConfigurationSection.tsx